<template>
  <div>
    <v-row>
      <v-col>
        <div>
          <h1>Sucursales -admin-</h1>

        </div>
        {{ sucursalSeleccionada }}
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-list style="background-color: transparent" flat two-line>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                ><div class="title">
                  Listado de sucursales
                </div></v-list-item-title
              >
              <v-list-item-subtitle>
                <div>
                  En el detalle de cada local, podrás agregar colaboradores,
                  configurar los medios de cobro de tus cajas.
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn large @click="goToRegisrarSucursal()">
                <v-icon color="grey lighten-1">mdi-plus</v-icon>
                <span class="text-subtitle">Agregar sucursal</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-list>
      <v-list-item-group v-if="sucursales.length > 0">
        <v-list-item
          @click="handleClick(sucursal)"
          v-for="sucursal in sucursales"
          :key="sucursal.id"
        >
          <v-list-item-avatar>
            <v-icon dark>mdi-bank</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ sucursal.nombre }}</v-list-item-title>
            <v-list-item-subtitle>{{
              sucursal.direccion
            }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-chip small :color="sucursal.activa ? 'green' : 'grey'" dark>
              {{ sucursal.activa ? 'Activa' : 'Inactiva' }}
            </v-chip>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click.stop="confirmarToggleActiva(sucursal)">
              <v-icon color="grey lighten-1">{{ sucursal.activa ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off' }}</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon>
              <v-icon color="grey lighten-1">mdi-menu-right</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
      <v-list-item v-else>
        <v-list-item-content>No se encontraron sucursales</v-list-item-content>
      </v-list-item>
    </v-list>

    <v-dialog v-model="dialogToggleActiva" max-width="420">
      <v-card>
        <v-card-title>{{ sucursalATogglear && sucursalATogglear.activa ? '¿Desactivar sucursal?' : '¿Activar sucursal?' }}</v-card-title>
        <v-card-text>
          <span v-if="sucursalATogglear && sucursalATogglear.activa">
            <strong>{{ sucursalATogglear.nombre }}</strong> dejará de facturarse en la mensualidad del SaaS.
          </span>
          <span v-else>
            <strong>{{ sucursalATogglear && sucursalATogglear.nombre }}</strong> volverá a facturarse en la mensualidad del SaaS.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogToggleActiva = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="togglingActiva" @click="toggleActivaConfirmado">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "EmpresaSucursalesList",
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters("admin", ["sucursalSeleccionada"]),
  },
  data() {
    return {
      sucursales: [],
      dialogToggleActiva: false,
      sucursalATogglear: null,
      togglingActiva: false,
    };
  },
  methods: {
    handleClick(sucursal) {
      this.$store.commit('admin/SET_SUCURSAL', sucursal);
      this.$router.push({
        name: "sucursalDatosGenerales",
        params: { uuid_sucursal: sucursal.uuid },
      });
    },
    goToRegisrarSucursal() {
      this.$router.push({
        name: "admin.sucursalRegistrar",
      });
    },
    confirmarToggleActiva(sucursal) {
      this.sucursalATogglear = sucursal;
      this.dialogToggleActiva = true;
    },
    async toggleActivaConfirmado() {
      this.togglingActiva = true;
      try {
        const nuevaActiva = !this.sucursalATogglear.activa;
        const { data } = await this.axios.post(
          `/sucursales/${this.sucursalATogglear.uuid}/activa`,
          { activa: nuevaActiva }
        );
        const sucursal = this.sucursales.find((s) => s.uuid === data.uuid);
        if (sucursal) sucursal.activa = data.activa;
        this.dialogToggleActiva = false;
      } catch (e) {
        this.$store.dispatch('alerts/showSnackbar', {
          text: 'No se pudo cambiar el estado de la sucursal',
          color: 'error',
          icon: 'mdi-alert',
        });
      } finally {
        this.togglingActiva = false;
      }
    },
  },
  watch: {
    // Observa cambios en la propiedad 'empresa'
    empresa: {
      immediate: true, // Para ejecutar la función cuando se crea el componente
      handler(newEmpresa) {
        if (!newEmpresa && this.$route.params.uuid) {
          // Si no hay 'empresa', pero hay un 'uuid' en los parámetros de la ruta
          const uuid = this.$route.params.uuid;

          // Realiza la solicitud de sucursales según el 'uuid'
          this.axios.get(`/sucursales?uuid=${uuid}`).then((response) => {
            this.sucursales = response.data;
          });
        } else if (newEmpresa && newEmpresa.uuid) {
          // Si hay 'empresa', utiliza su 'uuid'
          this.axios
            .get(`/sucursales?uuid=${newEmpresa.uuid}`)
            .then((response) => {
              this.sucursales = response.data;
            });
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
